<template>
  <div>
    <v-container fluid class="pa-0">
      <v-layout row wrap style="height: 65vh!important; overflow-y: scroll">
        <v-flex class="">
          <v-card @click="ViewRequestData(i)" v-for="i in AttendanceRequests" class="mb-3 card-r no-shadow pt-2 pb-2" color="white">
            <v-list tow-line subheader class="pa-0 transparent">
              <v-list-tile avatar>
                <v-list-tile-avatar height="80px" color="#077FFF">

                  <img :src="i.student_bookings_data[0].module.module_logo">
                </v-list-tile-avatar>
                <v-list-tile-content >
                  <v-list-tile-title class="text-primary font-weight-bold">
                    {{i.student_bookings_data[0].module.name}} <span class="f-14">( {{i.student_bookings_count}} )</span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text-primary font-weight-bold">
                    {{i.dateAndTime}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog class="pa-0 card-r no-shadow w-100" v-model="theory" width="500">
      <v-card class="px-2 pt-2 card-r no-shadow grey lighten-3">
        <v-toolbar class="transparent card-r no-shadow pl-3 text--black">
          <div class="pt-3">
            <v-checkbox color="primary" @change="selectAll(checkin)" v-model="checkin"></v-checkbox>
          </div>
          <div v-if="selectedRequestData.student_bookings_data" class="text-xs-left f-15 text-capitalize text--black">{{selectedRequestData.student_bookings_data[0].module.name}}<span class="f-12">({{selectedRequestData.student_bookings_data[0].date}})</span></div>
          <v-spacer></v-spacer>
          <div class="">
            <!--<v-btn @click="theory = false" class="ma-0"-->
            <!--icon small>-->
            <v-icon @click="theory = false" class="text--secondary mr-2">
              close
            </v-icon>
            <!--</v-btn>-->
          </div>
        </v-toolbar>
        <v-divider></v-divider>

         <v-alert
            :value="true"
            :type="alertType"
            v-if="alertType"
          >
            {{msg}}
          </v-alert>
        <v-layout row wrap style="">
          <v-flex xs12 class="">
            <v-card v-for="(data,index) in selectedRequestData.student_bookings_data" class="no-shadow transparent">
              <v-list class="pa-0 transparent">
              <!-- {{finalAttendance}} -->
                <v-list-tile
                  avatar>
                  <div class="right">
                    <v-checkbox ref="attendance" light :value="data" v-model="finalAttendance.IdList[index]" color="primary"></v-checkbox>
                  </div>
                  <v-list-tile-avatar size="40" class="mr-1 pt-1">
                    <img :src="data.student.image_path">
                  </v-list-tile-avatar>
                  <v-list-tile-content >
                    <v-list-tile-title class="text-primary pl-1 f-15 font-weight-bold">
                      {{data.student.name}}
                    </v-list-tile-title>

                    <v-list-tile-title class="text-primary f-15 font-weight-bold" v-if="data.required_result=='true'">
                      <v-radio-group v-model="finalAttendance.Status[index]" row class="transparent ma-0 pa-0">
                        <v-radio light label="Pass" value="pass" class="ma-0"></v-radio>
                        <v-radio light label="Absent" value="absent" class="ma-0"></v-radio>
                      </v-radio-group>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
        <v-card class="no-shadow py-2 transparent" v-if="finalAttendance.IdList.length!=0">
          <testing-complete-drg v-on:emitMethod="sendRequest"/>
          <!-- <drag v-on:emitMethod="sendRequest"/> -->
        </v-card>
      </v-card>
    </v-dialog>


    <v-dialog class="pa-0 card-r no-shadow w-100" v-model="snow" width="600">
      <v-card class="px-2 pt-2 card-r no-shadow grey lighten-3">
        <v-toolbar class="tow-clor-1 card-r no-shadow pl-3 text-white">
          <div class="mt-3">
            <v-checkbox dark color="white" v-model="checin"></v-checkbox>
          </div>
          <div class="text-xs-left f-15 text-capitalize" color="#002d4a">Snow Drive <span class="f-12">(Sep-29-2019)</span></div>
          <v-spacer></v-spacer>
          <div class="">
            <v-icon @click="snow = false" class="text-white mr-2">
              close
            </v-icon>
          </div>
        </v-toolbar>
        <v-layout row wrap style="overflow-y: scroll">
          <v-flex xs12 class="">
            <v-card class="no-shadow transparent"  v-for="i in 6">
              <v-list class="pa-0 ma-0 no-shadow transparent">
                <v-list-tile
                  v-for="i in itemss"
                  avatar
                  @click="">
                  <div class="right mt-2 ">
                    <v-checkbox light v-model="checin" color="primary"></v-checkbox>
                  </div>
                  <v-list-tile-avatar size="48" class="mr-1 pt-1" :color="i.active==null ? 'primary' : 'grey'">
                    <img src="https://cdn.vuetifyjs.com/images/cards/cooking.png">
                  </v-list-tile-avatar>
                  <v-list-tile-content >
                    <v-list-tile-title class="text-primary pl-1 f-15 font-weight-bold">
                      {{i.StudentName}}
                    </v-list-tile-title>
                    <v-list-tile-title class="text-primary f-15 font-weight-bold">
                      <v-radio-group  v-model="radios" row class="transparent ma-0 pa-0">
                        <v-radio light label="Pass" value="radio-1" color="primary darken-2" class="ma-0"></v-radio>
                        <v-radio light label="Fail" value="radio-2" color="primary darken-2" class="ma-0"></v-radio>
                        <v-radio light label="Absent" value="radio-3" color="primary darken-2" class="ma-0"></v-radio>
                      </v-radio-group>
                      <v-btn>dn</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
        <v-card class="no-shadow py-2 card-r pa-2" v-if="radios !== null">
          <testing-complete-drg/>
          <drag/>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  /*eslint-disable*/
  import TestingCompleteDrg from './TestingCompleteDrg'
  // import drag from './drag'
  import api from "@/utils/backend-api"

  export default {
    props:["teacher_id"],
    data () {
      return {
        checin: null,
        drags: false,
        theory: false,
        snow: false,
        ggg: false,
        gggs: false,
        row: null,
        radios: null,
        date: " 24/06/2019 ",
        items: [
          {
            active: true,
            id: '01',
            activea: true,
            title: 'Theory lession 1',
            nstudents: '12 Students ',
            src: '../../assets/classes/maneuver.png',
            subtitle: 'Sep-28-2019  - 02:00 Pm'
          },
        ],
        itemss: [
          {
            active: true,
            id: '01',
            activea: true,
            nstudents: '6 Students ',
            title: 'Snow Drive',
            StudentName: 'Student Name ',
            avatar: '../../assets/classes/maneuver.png',
            subtitle: 'Sep-29-2019'
          }
        ],
        AttendanceRequests:[],
        selectedRequestData:'',
        finalAttendance:{
          IdList:[],
          Status:[]
        },
        alertType:'',
        msg:''
      }
    },
    created:function(){
      this.getAttendanceRequests()
    },
    methods:{
      selectAll(value){
        if(value==false){
          this.finalAttendance.IdList=[]
        }else{
          this.finalAttendance.IdList=[]
          let all=this.selectedRequestData.student_bookings_data
          for(let x=0;x<all.length;x++){
            // debugger
            this.finalAttendance.IdList.push(all[x])
          }
        }

      },
      sendRequest(){
        var requests=[]
        let att=this.finalAttendance.IdList
        for(let x=0;x<att.length;x++){
          console.log(att[x])
          // debugger
          if(att[x]!=null){
            let result
            if(att[x].required_result=="true"){
              result=(this.finalAttendance.Status[x]=='pass')?'pass':"fail"
            }else if(att[x].required_result=="false"){
              result='pass'
            }


            let data={
              teacher_bookings_id:att[x].teacher_bookings_id,
              student_bookings_id:att[x].id,
              attendance:this.finalAttendance.Status[x]=='absent'?'Absent':"Present",
              result:result
              // signed_date:att[x].signed_date,
              // signed_time:att[x].signed_time,
              // signed_descrition:att[x].signed_descrition
            }
            requests.push(data)
          }
        }
        console.log(requests)
        this.updateAttendance(requests)
      },
      updateAttendance(data){
        this.alertType=""
        this.msg=""
        let self=this
        api.postData('admin/adminMarkPresendAbsent_2',{student_bookings:data,teacher_id:this.teacher_id})
        .then(res=>{

            // switch(data.attendance){
            //   case "Present": this.msg="Attendence request accepted";break;
            //   case "Absent":  this.msg="Attendence request rejected";break;
            // }
            self.alertType="success"
            self.msg="Attendance Successfully posted"
            setTimeout(()=>{
                self.theory=false
            },1000);
            self.getAttendanceRequests()
        }).catch(err=>{
            self.alertType="error"
            self.msg="Failed to submit"
        })
      },
      getAttendanceRequests(){
          let self=this
          api.postData('admin/adminGetAttendanceRequests',{teacher_id:this.teacher_id})
          .then(res=>{
            self.AttendanceRequests=res.data
          })
      },
      ViewRequestData(i){
        this.selectedRequestData=i
        this.finalAttendance.IdList=[]
        this.finalAttendance.Status=[]
        this.theory=true
        this.alertType=''
        this.msg=''
        this.checkin=false
      }

    },
    components: {
      TestingCompleteDrg,
      // drag
    }
  }
</script>
<style>
  .v-radio label {
    /*color: #077FFF !important;*/
    font-size: 10px !important;
    font-weight:bold !important;
  }
  .v-input--selection-controls__input{
    /*margin-right: 4px;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/teacher/SignRequest.vue